/*
  Este modelo foi generalizado apenas para utilizar no mock-up. Devido a limitacao do json-serve
  Apos a implementacao da api, deve especializar este modelo.
*/
import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { Item } from './item.model';
import { NTECH_API } from '../app.api';
import { FuncaoEquipamentoService } from '../funcao-equipamento/funcao-equipamento.service';
import { FabricanteService } from './../fabricante/fabricante.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css']
})
export class ItemComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  loadingVisible = false;
  colunasGridItem = [];
  listaFuncaoEquipamento = [];
  item = null;
  alturaGrid = null;
  listaFabricante = [];

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  listasForm = [
    {Nome: 'listaFuncaoEquipamento', status: false},
    {Nome: 'listaFabricante', status: false}
  ];

  editOptionsGridItem = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Item',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private funcaoEquipamentoService: FuncaoEquipamentoService,
    private fabricanteService: FabricanteService
  ) {
    this.loadingVisible = true;

    this.item = new CustomStore({
      insert: function (values) {
        values.DtCadastro = new Date;
        return http.post(`${NTECH_API}/item/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/item/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/item/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/item/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.fabricanteService.getFabricantes().subscribe(fabricantes => {
      this.listaFabricante = fabricantes;
      this.verificarListasCarregadas('listaFabricante');
    });

    this.funcaoEquipamentoService.getFuncaoEquipamentos().subscribe(funcaoEsquipamento => {
      this.listaFuncaoEquipamento = funcaoEsquipamento;
      this.verificarListasCarregadas('listaFuncaoEquipamento');
    });

    this.loadingVisible = false;
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  montaForm() {
    this.colunasGridItem = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'Descricao',
        dataType: 'string',
        caption: 'Descrição',
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatório.'
        }]
      },
      {
        dataField: 'IdFuncaoEquipamento',
        caption: 'Função do Equipamento',
        lookup: {
            dataSource: this.listaFuncaoEquipamento,
            displayExpr: 'DescricaoFuncaoEquipamento',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Função do equipamento é obrigatória.'
        }]
      },
      {
        dataField: 'MTBF',
        dataType: 'number',
        caption: 'MTBF',
        visible: false
      },
      {
        dataField: 'MTTR',
        dataType: 'number',
        caption: 'MTTR',
        visible: false
      },
      {
        dataField: 'DtCadastro',
        dataType: 'date',
        caption: 'Data do cadastro',
        editorOptions: { disabled: true },
        visible: false
      },
      {
        dataField: 'IdPessoa',
        caption: 'Fabricante do Equipamento',
        lookup: {
            dataSource: this.listaFabricante,
            displayExpr: 'Nome',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Marca do equipamento é obrigatória.'
        }]
      }
    ];
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      const foundItem = this.listasForm.find((fItem) => fItem.Nome === nomeLista);

      if (foundItem) {
        foundItem.status = true;
      }
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if ( (this.listasForm[0].status === true) &&
         (this.listasForm[1].status === true) ) {

      this.montaForm();

      return true;
    } else {
      return false;
    }
  }
  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/item/item.component.ts